import LazyVideo from "@/components/LazyVideo";

const MethodTeaseSection = () => (
  <div id="method-tease">
    <LazyVideo
      src="/Thinking_in_a_Line_Home_Page_Method_Perspective_s-size.mp4"
      className="relative w-full overflow-hidden border-y-2 border-white"
      style={{ aspectRatio: "2/1" }}
    />
  </div>
);

export default MethodTeaseSection;
